<h2 matDialogTitle>Oszczędzaj na rachunkach</h2>

<app-dobry-prad-offer-info
  *ngIf="step === offerStep.INFO"
  (action)="step = offerStep.PHONE_NUMBER"
></app-dobry-prad-offer-info>

<app-dobry-prad-offer-form
  *ngIf="step === offerStep.PHONE_NUMBER"
  (action)="step = offerStep.SUMMARY"
></app-dobry-prad-offer-form>

<app-change-biller-offer-summary *ngIf="step === offerStep.SUMMARY"></app-change-biller-offer-summary>
